export default __webpack_public_path__ + "static/pagely-stack-1516ade1bdb5890158adb65f21083dc0.svg";